"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAiLimitType = isAiLimitType;
function isAiLimitType(input) {
    return (typeof input === "string" &&
        [
            "ai_budget",
            "ai_rolling_window",
            "free_pronunciation",
            "free_monthly_budget",
            "free_dictation",
            "ai_generation",
        ].includes(input));
}
//# sourceMappingURL=aiBudget.js.map